<vex-ged-layout [loading]="loading" [canAddDoc]="canAddDoc">
  <!-- TODO PERMISSION [deletePermission]="[ENUM_PERMISSION.DELETE_HM_EQUIPMENT_DOCUMENT]"
            [customActionPermission]="[ENUM_PERMISSION.DOWNLOAD_HM_EQUIPMENT_DOCUMENT]"-->
  <base-data-table
    [dataSource]="dataSource"
    [displayedColumns]="displayedColumns"
    [feisColumns]="feisColumns"
    [showPaginator]="false"
    (onDeleteItem)="openDelete($event)"
    [showSort]="false"
    (onDownloadItem)="downloadDocument($event.DWDOCID)"
    [customColumnTemplate]="customColumnTemplateRef"
  ></base-data-table>

  <ng-template #customColumnTemplateRef let-column let-row="element" let-status="status">
    <div *ngIf="column === 'btnToPrev'">
      <button mat-icon-button (click)="preview(row)" [loading]="row.isLoading" color="primary">
        <mat-icon>remove_red_eye</mat-icon>
      </button>
    </div>
  </ng-template>
  <!--    <ng-template #customAction let-row="value">-->
  <!--        <button class="mat-menu-item" (click)="downloadDocument(row.DWDOCID)" *hasPermission="[ENUM_PERMISSION.DOWNLOAD_EQUIPMENT_DOCUMENT]">-->
  <!--            <mat-icon>file_download</mat-icon>-->
  <!--            Télécharger-->
  <!--        </button>-->
  <!--    </ng-template>-->
  <div dragFormZone [permissionBlock]="[ENUM_PERMISSION.UPDATE_EQUIPMENT]">
    <div fxLayout="column" *ngIf="!loading">
      <div class="w-full" [formGroup]="form">
        <mat-form-field class="w-full">
          <mat-label>Type de document</mat-label>
          <mat-select formControlName="documentType">
            <mat-option *ngFor="let type of documentTypes" [value]="type">{{ type }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <vex-drop-zone [files]="files"></vex-drop-zone>
      <button
        mat-raised-button
        color="primary"
        class="mt-4"
        fxFlexAlign="end"
        (click)="validForm()"
        [loading]="loadingSave"
        [disabled]="form.invalid || files.length === 0"
      >
        ENREGISTRER
      </button>
    </div>
  </div>
</vex-ged-layout>
